export const en = {
  personalInfo: {
    name: 'Ulrich Flynn NDELOKO SOBTEGOUYEM',
    title: 'Software Developer',
    fneNumber: 'FNE No: CO2-2023-1560',
    tagline: 'Developing software with precision, testing with purpose, and delivering quality by design',
    summary: 'Hi, I\'m Ulrich👋\n\nA Software Developer with over three years of professional experience designing, developing, and delivering software solutions. Passionate about technology and continuous learning, I enjoy solving complex problems and building applications that create real value for users.\n\nMy experience spans the full software development lifecycle, working with modern technologies including Python, JavaScript, TypeScript, React, Node.js, PostgreSQL, Docker, and Azure DevOps. Throughout my career, I\'ve also developed strong skills in Agile development, quality assurance, collaboration, and delivering high-quality software.\n\nCurrently pursuing a Bachelor of Technology in Software Development, I\'m seeking a Software Development Co-op opportunity where I can contribute my professional experience while continuing to grow within the Canadian tech industry. I\'m open to Co-op positions in Calgary or remote opportunities and am excited to collaborate with teams that value innovation, learning, and excellence.\n\nThank you for visiting, I look forward to the opportunity to contribute to your team.',
    social: {
      github: 'https://github.com/UlrichFlynn',
      linkedin: 'https://www.linkedin.com/in/ulrich-flynn-ndeloko-sobtegouyem-96431b208',
      twitter: ''
    },
    contact: {
      email: 'ndelokosuf@gmail.com',
      phone: '+1 (825) 779-2005',
      location: 'Calgary, Alberta, Canada'
    }
  },
  nav: {
    home: 'Home',
    about: 'About',
    projects: 'Projects',
    contact: 'Contact', // 'Contact me'
  },
  home: {
    title: 'Software Developer',
    subtitle: 'Passionate about crafting efficient solutions and ensuring software quality.',
    description: 'I combine development expertise with quality assurance to deliver robust and user-friendly applications.',
    whatIDo: 'What I Do',
    downloadMyResume: 'Download My Resume',
    skills: [
      { 
        title: 'Frontend Development', 
        description: 'Creating responsive and interactive user interfaces',
        icon: 'code' 
      },
      { 
        title: 'Backend Development', 
        description: 'Building robust server-side solutions',
        icon: 'build'
      },
      { 
        title: 'Problem Solving', 
        description: 'Analytical approach to challenges',
        icon: 'lightbulb'
      }
    ]
  },
  about: {
    title: 'About Me',
    introduction: 'My journey in technology began with a deep curiosity about how things work, which led me to pursue a career in software development. What excites me most is the intersection of clean code and quality assurance, where I can build robust applications while ensuring they meet the highest standards. I engage in reading, which helps me maintain a fresh perspective on problem-solving and creativity in my work.',
    experience: {
      title: 'Professional Experience',
      positions: [
        {
          title: 'Software Developer & QA Engineer',
          company: 'Biomedical Technical Engineering Services SARL',
          location: 'Yaounde, Cameroon',
          period: 'May 2024 to May 2025',
          responsibilities: [
            'Developed scalable event and asset management web applications using Node.js, Express.js, JavaScript and TypeScript.',
            'Implemented automated end-to-end testing with Cypress and performance testing with Grafana K6.',
            'Created reusable Express.js boilerplates, test automation utilities and prompt templates to accelerate development.',
            'Served as Scrum Master, facilitating Agile ceremonies and coordinating cross-functional delivery.'
          ]
        },
        {
          title: 'Software Developer',
          company: 'IS DEV EXPERTS',
          location: 'Douala, Cameroon',
          period: 'November 2023 to April 2024',
          responsibilities: [
            'Developed microservice-based backend systems supporting real-time communication.',
            'Collaborated with development teams using Agile practices.'
          ]
        },
        {
          title: 'Node.js Developer (Remote)',
          company: 'IdealBox',
          location: 'Buea, Cameroon',
          period: 'July 2023 to December 2023',
          responsibilities: [
            'Project analysis and planning',
            'Built backend services with Node.js and TypeScript.',
            'Integrated React-based application features.'
          ]
        },
        {
          title: 'Software Developer',
          company: 'SMARTCODE Group',
          location: 'Douala, Cameroon',
          period: 'May 2022 to May 2023',
          responsibilities: [
            'Contributed to project analysis.',
            'Development and maintenance of backend and web applications.',
            'Contributed to frontend development.',
            'Used Git version control system to manage different code versions.',
            'Organized client meetings.'
          ]
        },
        {
          title: 'Intern',
          company: 'SMARTCODE Group',
          location: 'Douala, Cameroon',
          period: 'July 2021 to May 2022',
          responsibilities: [
            'Learned Node.js, Express.js, and MongoDB.',
            'Took over and continued the backend development of a mobile application.',
            'Maintained the backend of a web application.',
            'Used Git version control system to manage different code versions.',
            'Organized client meetings.'
          ]
        },
        {
          title: 'Intern',
          company: 'AFRITEC LTD',
          location: 'Douala, Cameroon',
          period: 'June 2019 to August 2019',
          responsibilities: [
            'Learned programming fundamentals.',
            'Learned Java programming language.',
            'Developed an inventory management system using Java and SQL.'
          ]
        }
      ]
    },
    skills: {
      title: 'Technical Skills',
      categories: {
        frontend: 'Frontend',
        backend: 'Backend',
        testing: 'QA & Testing',
        prompting: 'Prompt Engineering',
        tools: 'Tools & Methods',
      },
    },
    education: {
      title: 'Education',
      items: [
        {
          title: 'Bachelor of Technology in Software Development (In Progress)',
          institution: 'Southern Alberta Institute of Technology (SAIT)',
          period: 'January 2026 to Present',
          location: 'Calgary, Alberta, Canada',
          description: 'A hands-on Bachelor of Technology program focused on full-stack software development, covering programming, web development, database design, software testing, security, algorithms, data structures, and software architecture. Through practical projects, I am developing the skills to design, build, test, and deploy user-focused software solutions.'
        },
        {
          title: 'JavaScript Essentials Certificate',
          institution: 'OpenEDG JavaScript Institute',
          period: 'February 2023 to April 2023',
          location: 'Online',
          description: 'The main objective of the course is to take you from a state of complete programming illiteracy to a level of programming knowledge that allows you to design, write, debug and run programs coded in JavaScript language, and understand the basic concepts of software development technology.'
        },
        {
          title: 'Version Control System Git',
          institution: 'Udacity',
          period: 'January 2023 to February 2023',
          location: 'Online',
          description: 'This course covers the essentials of using the Git version control system. You will be able to create a new Git repo, commit changes, and view the history of a repo. You will also learn how to organize your commits using tags and branches, and master the art of merging changes while eliminating troublesome merge conflicts.'
        },
        {
          title: 'NDG Linux Unhatched Certificate',
          institution: 'Cisco Networking Academy',
          period: 'January 2023',
          location: 'Online',
          description: 'Learn the basics of Linux software installation and configuration, and get started with the Linux command line.'
        },
        {
          title: 'Bachelor of Technology in Computer Software Engineering',
          institution: 'Institut Universitaire de la Côte',
          period: 'October 2020 to July 2021',
          location: 'Douala, Cameroon',
          description: 'A Bachelor of Technology program with a specialization in Software Engineering, focused on full-stack software development.'
        },
        {
          title: 'Higher National Diploma in Computer Software Engineering',
          institution: 'Institut Universitaire de la Côte',
          period: 'November 2018 to August 2020',
          location: 'Douala, Cameroon',
          description: 'A Higher National Diploma program with a specialization in Software Engineering, focused on full-stack software development.'
        },
        {
          title: 'General Certificate of Education (GCE) Advanced Level',
          institution: 'Government Bilingual High School Deido',
          period: '2014 to 2016',
          location: 'Douala, Cameroon'
        },
        {
          title: 'General Certificate of Education (GCE) Ordinary Level',
          institution: 'Government Bilingual High School Deido',
          period: '2009 to 2014',
          location: 'Douala, Cameroon'
        }
      ]
    },
    certifications: {
      title: "Licenses & Certifications",
      items: [
        {
          title: "JavaScript Essentials 1",
          period: "February 2023 - April 2023",
          issuer: "OpenEDG JavaScript Institute",
          id: "English 0323 cga"
        },
        {
          title: "NDG Linux Unhatched",
          period: "January 2023",
          issuer: "Cisco Networking Academy",
          id: "English 1022b"
        }
      ]
    }
  },
  projects: {
    title: 'Projects',
    viewProject: 'View Project',
    viewBackendRepo: 'View Backend Repository',
    viewFrontendRepo: 'View Frontend Repository',
    viewRepo: 'View Repository',
    technologies: 'Technologies',
    responsibilities: 'Key Responsibilities',
    items: [
      {
        title: 'JonEasyPro',
        period: 'November 2023 - April 2024',
        company: 'IS DEV EXPERTS',
        location: 'Douala, Cameroon',
        description: 'A bar management application that facilitates service and order tracking.',
        responsibilities: [
          'Developed backend services using Node.js and Express.js',
          'Implemented microservices architecture with Docker and Kafka',
          'Managed database design and implementation using MongoDB and Mongoose',
          'Applied agile methodologies and Git Flow for version control'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'Docker',
          'KafkaJS',
          'Git Flow',
          'Jira'
        ]
      },
      {
        title: 'Cible360',
        period: 'November 2022 - May 2023',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroon',
        description: 'A platform that guides users through their immigration process to Canada.',
        link: 'https://cible360.groupe-cible.ca',
        responsibilities: [
          'Developed backend logic and admin panel',
          'Organized client meetings',
          'Assisted in UI development',
          'Implemented user authentication and authorization'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'EJS',
          'Git',
          'Scrum',
          'Asana',
          'Trello'
        ]
      },
      {
        title: 'Cible Placement',
        period: 'May 2022 - November 2022',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroon',
        description: 'A web application helping job seekers find opportunities in Cameroon and Canada, while assisting companies in finding matching candidates.',
        link: 'https://ciblestafi.groupe-cible.ca',
        responsibilities: [
          'Developed backend logic and admin panel',
          'Organized client meetings',
          'Assisted in frontend development',
          'Implemented job matching algorithms'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'EJS',
          'Git',
          'Scrum',
          'Asana',
          'Trello'
        ]
      },
      {
        title: 'Prions Sans Cesse',
        period: 'January 2022 - April 2022',
        company: 'SMARTCODE Group',
        location: 'Douala, Cameroon',
        description: 'A platform that connects users worldwide as a community to pray together and share religious content.',
        link: 'https://prionssanscesse.com',
        responsibilities: [
          'Developed backend logic',
          'Developed admin panel',
          'Participated in client meetings'
        ],
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'REST API',
          'EJS',
          'Scrum',
          'Git',
          'Asana',
          'Trello'
        ]
      }
    ]
  },
  personalProjects: {
    title: 'Personal Projects',
    items: [
      {
        title: 'Catching the Copy: AST-Based Structural Similarity Checker - Backend',
        period: 'July 2026',
        description: 'An academic team project that developed an AST-based Python code similarity checker to identify potentially copied or structurally related code beyond traditional text matching. The system extracts structural features and combines cosine, Jaccard, and Longest Common Subsequence similarity metrics to generate a weighted similarity score and recommendation. The solution was implemented as a FastAPI REST API with a layered architecture and automated pytest testing. \nProject Type: Academic Team Project',
        linkRepo: 'https://github.com/UlrichFlynn/Catching-the-Copy-BO',
        technologies: [
          'Python',
          'FastAPI',
          'AST',
          'Pydantic',
          'pytest',
          'REST API'
        ]
      },
      {
        title: 'Task Management System - Backend',
        period: 'April 2026',
        description: 'A full-stack task management application with a secure RESTful API, JWT authentication, and user-specific task management. Built with Node.js and Express.js, the backend uses MongoDB and Mongoose for data persistence and implements bcrypt password hashing, CRUD operations, authentication middleware, error handling, and a structured controller-service architecture. The frontend is built with Next.js.',
        linkBackend: 'https://github.com/UlrichFlynn/task-management-system',
        technologies: [
          'Node.js',
          'Express.js',
          'MongoDB',
          'Mongoose',
          'JWT',
          'bcrypt',
          'Next.js'
        ]
      },
      {
        title: 'CaeliCast - Weather Forecasting App',
        period: 'May 2025',
        description: 'A responsive weather application built with Next.js and React that uses the WeatherAPI.com API to provide real-time weather information for any location. Features a modern interface, visual weather indicators, reusable components, and responsive design using Tailwind CSS.',
        link: 'https://weather-app-alpha-khaki-24.vercel.app/',
        linkRepo: 'https://github.com/UlrichFlynn/weather-app',
        technologies: [
          'Next.js',
          'React',
          'WeatherAPI.com API',
          'Tailwind CSS (for styling)'
        ]
      },
      {
        title: 'MailFile',
        period: 'September 2023',
        description: 'A small fullstack project built with Node.js and React. The goal of this application is to transfer large files, similar to WeTransfer and MailBigFile.',
        linkBackend: 'https://github.com/UlrichFlynn/Back-MailFile',
        linkFrontend: 'https://github.com/UlrichFlynn/Front-MailFile',
        technologies: [
          'Node.js',
          'React',
          'Express.js',
          'MongoDB',
          'Tailwind CSS'
        ]
      },
      {
        title: 'Cloud Kitchen Web',
        period: 'January 2023',
        description: 'A static website for a restaurant.',
        link: 'https://ulrichflynn.github.io/CloudChickenWeb-Tuto/',
        linkRepo: 'https://github.com/UlrichFlynn/CloudChickenWeb-Tuto',
        technologies: [
          'HTML',
          'CSS',
          'JavaScript',
          'Angular'
        ]
      }
    ]
  },
  contact: {
    title: 'Contact Me',
    subtitle: 'Get in touch',
    form: {
      name: 'Name',
      email: 'Email',
      message: 'Message',
      submit: 'Send Message',
      success: 'Your message has been sent successfully!',
      error: 'There was an error sending your message. Please try again.'
    },
    info: {
      title: 'Contact Information',
      email: 'Email me at',
      phone: 'Call me at',
      location: 'Find me in',
      availability: 'Available for Co-op opportunities in Calgary or remote positions. Open to collaboration and eager to contribute to innovative projects.'
    }
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success!',
  },
  skills: {
    title: 'Skills',
    categories: {
      webDev: {
        title: 'Web Development',
        skills: ['HTML', 'CSS', 'JavaScript', 'TypeScript', 'Python']
      },
      frameworks: {
        title: 'Frameworks & Libraries',
        skills: ['React', 'Angular', 'Node.js', 'FastAPI']
      },
      databases: {
        title: 'Databases',
        skills: ['MongoDB', 'PostgreSQL']
      },
      apis: {
        title: 'APIs & Communication',
        skills: ['REST API', 'GraphQL', 'KafkaJS']
      },
      devOps: {
        title: 'DevOps & Tools',
        skills: ['Docker', 'Azure DevOps', 'Git', 'Git flow']
      },
      testing: {
        title: 'Testing & Quality',
        skills: ['Cypress', 'K6', 'Code Review']
      },
      other: {
        title: 'Other Technologies',
        skills: ['Prompt Engineering', 'Microservice Architecture']
      },
      methodologies: {
        title: 'Methodologies',
        skills: ['Agile Scrum']
      }
    }
  },
  interests: {
    title: 'Interests',
    items: [
      {
        name: 'Reading',
        icon: 'book'
      },
      {
        name: 'Sports',
        icon: 'sports'
      },
      {
        name: 'Listening to Music',
        icon: 'music'
      }
    ]
  },
  strengths: {
    title: 'Strengths',
    items: [
      {
        name: 'Organized',
        icon: 'organize'
      },
      {
        name: 'Punctual',
        icon: 'time'
      },
      {
        name: 'Team Player',
        icon: 'team'
      },
      {
        name: 'Disciplined',
        icon: 'discipline'
      }
    ]
  },
  languages: {
    title: 'Languages',
    items: [
      {
        name: 'English',
        level: ' '
      },
      {
        name: 'French',
        level: ' '
      }
    ]
  },
  contactInfo: {
    title: 'Contact',
    email: 'ulrichflynn9@gmail.com',
    location: 'Yaoundé',
    phone: '6 94 08 82 05',
    labels: {
      email: 'Email',
      location: 'Location',
      phone: 'Phone'
    }
  },
};
